/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EvaluationParameterDto } from './EvaluationParameterDto';
import {
    EvaluationParameterDtoFromJSON,
    EvaluationParameterDtoFromJSONTyped,
    EvaluationParameterDtoToJSON,
} from './EvaluationParameterDto';
import type { QaEquipmentCatalogDto } from './QaEquipmentCatalogDto';
import {
    QaEquipmentCatalogDtoFromJSON,
    QaEquipmentCatalogDtoFromJSONTyped,
    QaEquipmentCatalogDtoToJSON,
} from './QaEquipmentCatalogDto';
import type { ISetupParameterFilter } from './ISetupParameterFilter';
import {
    ISetupParameterFilterFromJSON,
    ISetupParameterFilterFromJSONTyped,
    ISetupParameterFilterToJSON,
} from './ISetupParameterFilter';
import type { MedicalSystemCatalogDto } from './MedicalSystemCatalogDto';
import {
    MedicalSystemCatalogDtoFromJSON,
    MedicalSystemCatalogDtoFromJSONTyped,
    MedicalSystemCatalogDtoToJSON,
} from './MedicalSystemCatalogDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface DataSetFilterTemplateDto
 */
export interface DataSetFilterTemplateDto {
    /**
     * 
     * @type {Array<TaskTypeDescription>}
     * @memberof DataSetFilterTemplateDto
     */
    availableTaskTypes: Array<TaskTypeDescription>;
    /**
     * 
     * @type {Array<MedicalSystemCatalogDto>}
     * @memberof DataSetFilterTemplateDto
     */
    availableTargetSystems: Array<MedicalSystemCatalogDto>;
    /**
     * 
     * @type {Array<QaEquipmentCatalogDto>}
     * @memberof DataSetFilterTemplateDto
     */
    availableSupportSystems: Array<QaEquipmentCatalogDto>;
    /**
     * 
     * @type {Array<ISetupParameterFilter>}
     * @memberof DataSetFilterTemplateDto
     */
    targetSystemSetupFilters: Array<ISetupParameterFilter>;
    /**
     * 
     * @type {Array<ISetupParameterFilter>}
     * @memberof DataSetFilterTemplateDto
     */
    supportSystemSetupFilters: Array<ISetupParameterFilter>;
    /**
     * 
     * @type {Array<EvaluationParameterDto>}
     * @memberof DataSetFilterTemplateDto
     */
    evaluationParameterFilters: Array<EvaluationParameterDto>;
    /**
     * 
     * @type {string}
     * @memberof DataSetFilterTemplateDto
     */
    $type?: DataSetFilterTemplateDtoTypeEnum;
}


/**
 * @export
 */
export const DataSetFilterTemplateDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoDataSetFilterTemplateDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.DataSetFilterTemplateDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DataSetFilterTemplateDtoTypeEnum = typeof DataSetFilterTemplateDtoTypeEnum[keyof typeof DataSetFilterTemplateDtoTypeEnum];



/**
 * Check if a given object implements the DataSetFilterTemplateDto interface.
 */
export function instanceOfDataSetFilterTemplateDto(value?: unknown): value is DataSetFilterTemplateDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DataSetFilterTemplateDtoTypeEnum)[0];
}

export function DataSetFilterTemplateDtoFromJSON(json: any): DataSetFilterTemplateDto {
    return DataSetFilterTemplateDtoFromJSONTyped(json, false);
}

export function DataSetFilterTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSetFilterTemplateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'availableTaskTypes': ((json['availableTaskTypes'] as Array<any>).map(TaskTypeDescriptionFromJSON)),
        'availableTargetSystems': ((json['availableTargetSystems'] as Array<any>).map(MedicalSystemCatalogDtoFromJSON)),
        'availableSupportSystems': ((json['availableSupportSystems'] as Array<any>).map(QaEquipmentCatalogDtoFromJSON)),
        'targetSystemSetupFilters': ((json['targetSystemSetupFilters'] as Array<any>).map(ISetupParameterFilterFromJSON)),
        'supportSystemSetupFilters': ((json['supportSystemSetupFilters'] as Array<any>).map(ISetupParameterFilterFromJSON)),
        'evaluationParameterFilters': ((json['evaluationParameterFilters'] as Array<any>).map(EvaluationParameterDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DataSetFilterTemplateDtoToJSON(value?: DataSetFilterTemplateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'availableTaskTypes': ((value['availableTaskTypes'] as Array<any>).map(TaskTypeDescriptionToJSON)),
        'availableTargetSystems': ((value['availableTargetSystems'] as Array<any>).map(MedicalSystemCatalogDtoToJSON)),
        'availableSupportSystems': ((value['availableSupportSystems'] as Array<any>).map(QaEquipmentCatalogDtoToJSON)),
        'targetSystemSetupFilters': ((value['targetSystemSetupFilters'] as Array<any>).map(ISetupParameterFilterToJSON)),
        'supportSystemSetupFilters': ((value['supportSystemSetupFilters'] as Array<any>).map(ISetupParameterFilterToJSON)),
        'evaluationParameterFilters': ((value['evaluationParameterFilters'] as Array<any>).map(EvaluationParameterDtoToJSON)),
        '$type': value['$type'],
    });
}

